export const THEME_LOADED_EVENT = 'ibk:theme-loaded';
export const THEME_CLEARED_EVENT = 'ibk:theme-cleared';
export const MAX_NAME_LENGTH = 60;
